import React from 'react';
import UpdatedAgreementDialog from './UpdatedAgreementDialog';
import {MapStateToProps, MapDispatchToProps, connect} from 'react-redux';
import {isLoggedIn} from '../../selectors/user.selectors';
import eulaActions from '../../actions/eula.actions';
import {getIsEulasLoading} from '../../selectors/eula.selectors';

interface StateProps {
    isLoggedIn: boolean;
    isEulasLoading: boolean;
}
interface DispatchProps {
    fetchAffiliateAgreement: () => void;
    fetchCodeOfConduct: () => void;
}
type Props = StateProps & DispatchProps;

const mapStateToProps: MapStateToProps<StateProps, {}, any> = state => ({
    isLoggedIn: isLoggedIn(state),
    isEulasLoading: getIsEulasLoading(state)
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, {}> = {
    fetchAffiliateAgreement: eulaActions.getAffiliateAgreement,
    fetchCodeOfConduct: eulaActions.getConductAgreement
};

class SmartUpdatedAgreementDialog extends React.Component<Props> {
    componentDidMount() {
        this.props.fetchAffiliateAgreement();
        this.props.fetchCodeOfConduct();
    }

    render() {
        if (!this.props.isLoggedIn) {
            return null;
        }

        if (this.props.isEulasLoading) {
            return null;
        }

        return <UpdatedAgreementDialog />;
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SmartUpdatedAgreementDialog);
